<template>
  <!-- 地图选择器 -->
  <yxt-dialog
    :title="title"
    :visible.sync="visible"
    :cutline="false"
    width="550px"
    :show-close="false"
    :append-to-body="append"
    :modal-append-to-body="body"
    @close="closeHandler"
  >
    <template v-if="visible">
      <yxtbiz-amap
        v-if="mapInfo && mapInfo.geolocation && mapInfo.geolocation.length"
        ref="offlineMap"
        width="500"
        height="500"
        :address="mapInfo.address"
        :geolocation="mapInfo.geolocation"
        poi
        @complete="complete"></yxtbiz-amap>
      <yxtbiz-amap
        v-else
        ref="offlineMap"
        width="500"
        height="500"
        poi
        @complete="complete"></yxtbiz-amap>
    </template>

    <span slot="footer" class="dialog-footer">
      <yxt-button @click="closeHandler">{{ $t('pc_ulcd_btn_cancel') }}</yxt-button>
      <yxt-button type="primary" @click="getAddress">{{ $t('pc_ulcd_btn_done') }}</yxt-button>
      <!-- <yxt-button type="primary" @click="changeAddress">修改地址</yxt-button> -->
    </span>
  </yxt-dialog>
</template>

<script>
export default {
  name: 'map-select',
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default() { return this.$t('pc_ulcd_lbl_maptitle'); } },
    obj: {
      type: Object,
      default() {
        return {};
      }
    },
    mapAddress: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      body: false,
      append: true,
      mapInfo: {
        address: '',
        geolocation: []
      },
      isInited: false// 是否已初始化
    };
  },
  watch: {
    mapAddress: {
      handler(nval, oval) {
        this.mapInfo = {
          address: nval.address,
          geolocation: nval.geolocation
        };
      },
      immediate: true
    }
  },
  mounted() {

  },
  methods: {
    changeAddress() {
      this.$refs.offlineMap.geoCode();
    },
    // 获取地址
    getAddress() {
      console.log(this.mapInfo);
      this.$emit('mapAdressChange', this.mapInfo);
      this.closeHandler();
    },
    // 关闭弹框
    closeHandler() {
      this.$emit('update:visible', false);
    },
    // 选择地址回调
    complete(obj) {
      this.isInited = true;
      this.mapInfo.address = obj.name;
      this.mapInfo.geolocation = obj.location || this.mapInfo.geolocation;
      console.log(obj);
    }
  }
};
</script>
